import { render, staticRenderFns } from "./BarKemajuan.vue?vue&type=template&id=548dc12c&scoped=true"
import script from "./BarKemajuan.vue?vue&type=script&lang=js"
export * from "./BarKemajuan.vue?vue&type=script&lang=js"
import style0 from "./BarKemajuan.vue?vue&type=style&index=0&id=548dc12c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548dc12c",
  null
  
)

export default component.exports